// ---------------------------------------------------------------------------
// DSS-21: Canonical hover animation presets (10) — shared published contract
// ---------------------------------------------------------------------------

import type { DssHoverPresetId } from "@ease/page-builder";

export interface HoverAnimationPreset {
  readonly id: DssHoverPresetId;
  readonly name: string;
  readonly css: string;
}

export const HOVER_ANIMATIONS: readonly HoverAnimationPreset[] = [
  {
    id: "grow",
    name: "Grow",
    css: `:hover { transform: scale(1.1); transition: transform 300ms ease; }`,
  },
  {
    id: "shrink",
    name: "Shrink",
    css: `:hover { transform: scale(0.9); transition: transform 300ms ease; }`,
  },
  {
    id: "pulse",
    name: "Pulse",
    css: `:hover { animation: dss-pulse 1s ease infinite; }
@keyframes dss-pulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }`,
  },
  {
    id: "bounce",
    name: "Bounce",
    css: `:hover { animation: dss-bounce 400ms ease; }
@keyframes dss-bounce { 0%, 100% { transform: translateY(0); } 40% { transform: translateY(-8px); } 60% { transform: translateY(-4px); } }`,
  },
  {
    id: "rotate",
    name: "Rotate",
    css: `:hover { transform: rotate(4deg); transition: transform 300ms ease; }`,
  },
  {
    id: "wobble",
    name: "Wobble",
    css: `:hover { animation: dss-wobble 800ms ease; }
@keyframes dss-wobble { 0% { transform: translateX(0); } 15% { transform: translateX(-6px) rotate(-5deg); } 30% { transform: translateX(4px) rotate(3deg); } 45% { transform: translateX(-4px) rotate(-3deg); } 60% { transform: translateX(2px) rotate(2deg); } 75% { transform: translateX(-1px) rotate(-1deg); } 100% { transform: translateX(0); } }`,
  },
  {
    id: "float",
    name: "Float",
    css: `:hover { transform: translateY(-6px); transition: transform 300ms ease; }`,
  },
  {
    id: "sink",
    name: "Sink",
    css: `:hover { transform: translateY(6px); transition: transform 300ms ease; }`,
  },
  {
    id: "shadowGlow",
    name: "Shadow Glow",
    css: `:hover { box-shadow: 0 0 16px 4px var(--color-primary); transition: box-shadow 300ms ease; }`,
  },
  {
    id: "ripple",
    name: "Ripple",
    css: `:hover { animation: dss-ripple 600ms ease; }
@keyframes dss-ripple { 0% { box-shadow: 0 0 0 0 var(--color-primary); } 100% { box-shadow: 0 0 0 12px transparent; } }`,
  },
];

/**
 * Find a hover preset by ID.
 */
export function findHoverPreset(id: string): HoverAnimationPreset | undefined {
  return HOVER_ANIMATIONS.find((p) => p.id === id);
}
